export enum ReconcileAction {
  CREDIT = "CREDIT",
  REFUND = "REFUND",
}

export enum ReconcileMethod {
  NORMAL = "NORMAL",
  PLATFORM_ENDPOINT = "PLATFORM_ENDPOINT",
}

export enum ReconcileResolvedAs {
  WON = "won",
  LOST = "lost",
  VOID = "void",
}
